import { useTheme } from '@mui/material'
import React from 'react'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const MoneyFillIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.common.white
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='54'
      height='54'
      viewBox='0 0 54 54'
      fill='none'>
      <path
        d='M35.7376 24.9288C31.8323 21.0236 25.5007 21.0236 21.5954 24.9288C17.6902 28.8341 17.6902 35.1657 21.5954 39.0709C25.5007 42.9762 31.8323 42.9762 35.7376 39.0709'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <circle
        cx='28.6665'
        cy='32'
        r='20'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M30.7875 7.36223C28.1351 6.06283 25.1527 5.33333 22 5.33333C10.9543 5.33333 2 14.2876 2 25.3333C2 27.8535 2.46613 30.2648 3.31687 32.4857'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M32 2C43.0457 2 52 10.9543 52 22'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17 28.6667H27'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17 35.3333H27'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
